import React, { useState } from 'react';
import { Mail, Check } from 'lucide-react';
import { subscribeNewsletter } from '../lib/portalApi';
import { useT, useLanguage } from '../i18n/LanguageContext';

export default function NewsletterSignup() {
  const t = useT();
  const { lang } = useLanguage();
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | sending | done | error

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || state === 'sending') return;
    setState('sending');
    try {
      await subscribeNewsletter(email.trim(), '', lang);
      setState('done');
      setEmail('');
    } catch {
      setState('error');
    }
  };

  return (
    <div className="mb-12 flex flex-col gap-6 rounded-[28px] border border-white/10 bg-white/[0.03] p-8 md:flex-row md:items-center md:justify-between">
      <div>
        <h3 className="text-xl font-bold text-white">{t('newsletter.title')}</h3>
        <p className="mt-1 text-sm text-white/60">{t('newsletter.description')}</p>
      </div>
      {state === 'done' ? (
        <p className="inline-flex items-center gap-2 rounded-full bg-[#1fa5a3]/15 px-5 py-3 text-sm font-semibold text-[#1fa5a3]">
          <Check className="h-4 w-4" /> {t('newsletter.success')}
        </p>
      ) : (
        <form onSubmit={submit} className="flex w-full max-w-md gap-2">
          <div className="relative flex-1">
            <Mail className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-white/40" />
            <input
              type="email"
              required
              value={email}
              onChange={(e) => { setEmail(e.target.value); if (state === 'error') setState('idle'); }}
              placeholder={t('newsletter.placeholder')}
              className="w-full rounded-full border border-white/15 bg-white/5 py-3 pl-11 pr-4 text-sm text-white placeholder:text-white/40 outline-none focus:border-[#1fa5a3]"
            />
          </div>
          <button
            type="submit"
            disabled={state === 'sending'}
            className="flex-shrink-0 rounded-full bg-[#1fa5a3] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#188b89] disabled:opacity-60"
          >
            {state === 'sending' ? '…' : t('newsletter.button')}
          </button>
        </form>
      )}
      {state === 'error' ? <p className="text-sm text-red-300">{t('newsletter.error')}</p> : null}
    </div>
  );
}
